import React, { useEffect, useState } from "react";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";
// import Tooltip from "@mui/material/Tooltip";

import {
    Alert, Row,
    Col,
    Card
} from "reactstrap";
import { makeStyles } from "@mui/styles";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SearchIcon from "@mui/icons-material/Search";
import IconButton from "@mui/material/IconButton";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import BackButton from "../../components/BackButton/BackButton";
const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const ViewReversal = () => {
    const classes = useStyles();

    return (
        <>

            <Layout>
                <BackButton />

                <Card>
                    <TableContainer component={Paper} className="my-3">
                        <Table className={classes.table}>
                            <TableHead>
                                <TableRow className="tableHeaderColor">

                                    <TableCell
                                        align="center"
                                        style={{ fontWeight: "bold", color: "white" }}
                                    >
                                        Tracking ID{" "}
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ fontWeight: "bold", color: "white" }}
                                    >
                                        {" "}
                                        Transaction ID
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ fontWeight: "bold", color: "white" }}
                                    >
                                        {" "}
                                        Description
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ fontWeight: "bold", color: "white" }}
                                    >
                                        {" "}
                                        Captured Amount (in EUR)
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ fontWeight: "bold", color: "white" }}
                                    >
                                        Currency
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ fontWeight: "bold", color: "white" }}
                                    >
                                        Status
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ fontWeight: "bold", color: "white" }}
                                    >
                                        Reason for Reversal*
                                    </TableCell>
                                    <TableCell
                                        align="center"
                                        style={{ fontWeight: "bold", color: "white" }}
                                    >
                                        Reason for Amount*
                                    </TableCell>
                                    {/* <TableCell
                                        align="center"
                                        style={{ fontWeight: "bold", color: "white" }}
                                    >
                                        Action
                                    </TableCell> */}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow>
                                    <TableCell align="center">
                                        14952
                                    </TableCell>
                                    <TableCell align="center">
                                        195657
                                    </TableCell>
                                    <TableCell align="center">
                                        Description
                                    </TableCell>
                                    <TableCell align="center">
                                        67.34
                                    </TableCell>
                                    <TableCell align="center">
                                        USD
                                    </TableCell>
                                    <TableCell align="center">
                                        reversed
                                    </TableCell>
                                    <TableCell align="center">
                                        <TextField id="" label="" />

                                    </TableCell>
                                    <TableCell align="center">
                                        <TextField id="" label="21.22" />

                                    </TableCell>



                                </TableRow>
                            </TableBody>

                        </Table>

                    </TableContainer>

                </Card>
            </Layout>
        </>
    )
}

export default ViewReversal